import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAll = (state, { allOperator }) => {
  if (!allOperator) return state;
  return state.merge({ allOperator });
};

const setFactoryLabours = (state, { factoryLaboursData }) => {
  if (!factoryLaboursData) return state;
  return state.merge({ factoryLaboursData });
};

const setFactoryLaboursById = (state, { factoryLaboursDataById }) => {
  if (!factoryLaboursDataById) return state;
  return state.merge({ factoryLaboursDataById });
};

const setLaboursData = (state, { laboursData }) => {
  if (!laboursData) return state;
  return state.merge({ laboursData });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setIsOperatorIdReserved = (state, { isReserved }) => {
  return state.merge({ isReserved });
};

const setOperatorsByDepartmentId = (state, { departmentOperators }) => {
  return state.merge({ departmentOperators });
};

const setOperatorSkills = (state, { operatorSkills }) => {
  return state.merge({ operatorSkills });
};

const setOperatorAssigned = (state, { operatorAssigned }) => {
  return state.merge({ operatorAssigned });
};

const setOperatorAssignedLoader = (state, { operatorAssignedLoader }) => {
  return state.merge({ operatorAssignedLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },

  {
    actionType: ActionTypes.SET_FACTORY_LABOURS,
    actionFunction: setFactoryLabours,
  },

  {
    actionType: ActionTypes.SET_FACTORY_LABOURS_BY_ID,
    actionFunction: setFactoryLaboursById,
  },
  {
    actionType: ActionTypes.SET_LABOURS,
    actionFunction: setLaboursData,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_IS_OPERATOR_ID_RESERVED,
    actionFunction: setIsOperatorIdReserved,
  },
  {
    actionType: ActionTypes.SET_OPERATORS_BY_DEPARTMENT_ID,
    actionFunction: setOperatorsByDepartmentId,
  },
  {
    actionType: ActionTypes.SET_OPERATOR_SKILLS,
    actionFunction: setOperatorSkills,
  },
  {
    actionType: ActionTypes.SET_OPERATOR_ASSIGNED,
    actionFunction: setOperatorAssigned,
  },
  {
    actionType: ActionTypes.SET_OPERATOR_ASSIGNED_LOADER_STATUS,
    actionFunction: setOperatorAssignedLoader,
  },
];
